import {BlockPosition} from "./BlockPosition.js";

class ChordDegree {
    constructor(jsonStructure) {
        // console.log("ChordDegree constructor received:", JSON.stringify(jsonStructure));
        
        // Default values if structure is undefined
        if (!jsonStructure) {
            this.sharp_flat = '';
            this.note = '';
            // console.log("ChordDegree initialized with empty values");
            return;
        }
        this.sharp_flat = jsonStructure.sharp_flat;
        this.note = jsonStructure.note;
        // console.log("ChordDegree initialized with:", { sharp_flat: this.sharp_flat, note: this.note });
    }
}
class Bass {
    constructor(jsonStructure) {
        // Default values if structure is undefined
        if (!jsonStructure) {
            this.sharp_flat = '';
            this.note = '';
            return;
        }
        this.sharp_flat = jsonStructure.sharp_flat;
        this.note = jsonStructure.note;
    }
}

export class ChordAnnotationBlock {
    constructor(jsonStructure) {
        this.block_position = new BlockPosition(jsonStructure.block_position);
        this.completed = jsonStructure.completed || false;

        // Handle chord_degree properly, make defensive copy before passing
        if (jsonStructure.chord_degree) {
            // Clone the object to ensure we don't lose data
            const chordDegreeData = {
                note: jsonStructure.chord_degree.note,
                sharp_flat: jsonStructure.chord_degree.sharp_flat
            };
            this.chord_degree = new ChordDegree(chordDegreeData);
        } else {
            this.chord_degree = new ChordDegree(null);
        }
        
        // Set chord_type
        this.chord_type = jsonStructure.chord_type || '';
        
        // Set bass
        this.bass = new Bass(jsonStructure.bass);
    }
}
